import { render } from "./RouletteComponent.vue?vue&type=template&id=dba084ea&scoped=true"
import script from "./RouletteComponent.vue?vue&type=script&lang=js"
export * from "./RouletteComponent.vue?vue&type=script&lang=js"

import "./RouletteComponent.vue?vue&type=style&index=0&id=dba084ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dba084ea"]])

export default __exports__